<template>
  <div>
    <DebugLandingRow v-if="$store.state.isDev"/>
    <InitialUserView/>
  </div>
</template>

<script>
import ServiceDescription from '../components/ServiceDescription'
import VideoExplain from '../components/VideoExplain'
import DebugLandingRow from '../components/DebugLandingRow';
import InitialUserView from "../components/InitialUserView";

export default {
  name: 'Landing',
  components: { InitialUserView, DebugLandingRow,  ServiceDescription, VideoExplain},
  async created() {
    this.$store.dispatch('logVisit');
  }
}
</script>

<style scoped>

</style>
